// extracted by mini-css-extract-plugin
export default {"black25":"rgba(0, 0, 0, 0.25)","image":"ni","wrapper":"nj"};